import axios from 'axios'

export const fetchExperiences = async() => {
  try {
    return await axios.get(`experiences`)
  } catch (error) {
    throw error.response
  }
}

export const fetchExperience = async(id) => {
  try {
    return await axios.get(`experiences/${id}`)
  } catch (error) {
    throw error.response
  }
}
